// import React, { Fragment, useEffect, useState } from "react";
// import MyEditor from "./tools/MyEditor";
// import {
//   OpenTextGet,
//   OpenTextSet,
//   deleteOpenText,
//   addOpenText,
// } from "../server/OpenText";
// import { setPreload } from "../server/CartsOpen";
// import DOMPurify from "dompurify";
// import { useSelector, useDispatch } from "react-redux";
// import { globalFileIcon } from "../../axiosInstance";

// const OpenText = ({ ShowHome }) => {
//   const dispatch = useDispatch();
//   const [homeObj, setHomeObj] = useState([]);
//   const [editId, setEditId] = useState(null);
//   const role = useSelector((state) => state.user.role);

//   const deleteText = (id) => {
//     deleteOpenText(id)
//       .then(() => {
//         setHomeObj([...homeObj.filter((msg) => msg.Id !== id)]);
//       })
//       .catch(() => console.log("error"));
//   };

//   useEffect(() => {
//     OpenTextGet()
//       .then((x) => setHomeObj(x.data))
//       .catch(() => console.log("error"));
//   }, [role]);

//   const createMarkup = (html) => {
//     return {
//       __html: DOMPurify.sanitize(html),
//     };
//   };

//   const convertContentToHTML = (value, type, Id) => {
//     const obj = [...homeObj];
//     const index = obj.findIndex((x) => x.Id === Id);
//     obj[index][type] = value;
//     setHomeObj(obj);
//   };

//   const addMassage = () => {
//     const today = new Date();
//     today.setUTCHours(0, 0, 0, 0);
//     const tomorrow = new Date(today);
//     tomorrow.setUTCDate(today.getUTCDate() + 1);
//     const val = {
//       Active: 1,
//       FromDate: today.toISOString(),
//       OrderNumber: null,
//       Text: " ",
//       ToDate: tomorrow.toISOString(),
//     };
//     addOpenText(val)
//       .then((x) => {
//         setHomeObj([...homeObj, { ...val, Id: x.data.id }]);
//         setEditId(x.data.id);
//       })
//       .catch(() => console.log("error"));
//   };

//   const save = (Id) => {
//     dispatch(setPreload(true));
//     const obj = [...homeObj];
//     const index = obj.findIndex((x) => x.Id === Id);

//     OpenTextSet(obj[index])
//       .then((x) => {
//         obj[index] = x.data;
//         setHomeObj(obj);
//         setEditId(null);
//       })
//       .catch(() => console.log("error"))
//       .finally(() => dispatch(setPreload(false)));
//   };

//   return (
//     <section className="system-message">
//       <p className="header-system-text">כדאי שתדעו!</p>
//       <span className="system-body">
//         <div className="system-edit-text">
//           {homeObj.map((x) =>
//             ShowHome && role && editId === x.Id ? (
//               <MyEditor
//                 key={x.Id}
//                 homeObj={x}
//                 save={save}
//                 convertContentToHTML={convertContentToHTML}
//               />
//             ) : new Date(x.ToDate) >= new Date() || (role && ShowHome) ? (
//               <Fragment key={x.Id}>
//                 <div
//                   className="system-text"
//                   dangerouslySetInnerHTML={createMarkup(x.Text)}
//                 ></div>
//                 {role && ShowHome ? (
//                   <Fragment>
//                     <div>{x.FromDate.split("T")[0]}</div>
//                     <div>{x.ToDate.split("T")[0]}</div>

//                     <button className="btn" onClick={() => setEditId(x.Id)}>
//                       עריכה
//                     </button>
//                     <button className="btn" onClick={() => deleteText(x.Id)}>
//                       מחיקה
//                     </button>
//                   </Fragment>
//                 ) : null}
//               </Fragment>
//             ) : null,
//           )}
//           {role && ShowHome && !homeObj.findIndex((x) => x.Id === -1) >= 0 ? (
//             <button className="btn" onClick={addMassage}>
//               הוספת חדש
//             </button>
//           ) : null}
//         </div>
//       </span>
//     </section>
//   );
// };

// export default OpenText;

import React, { Fragment, useEffect, useState, useCallback } from "react";
import MyEditor from "./tools/MyEditor";
import {
  OpenTextGet,
  OpenTextSet,
  deleteOpenText,
  addOpenText,
} from "../server/OpenText";
import { setPreload } from "../server/CartsOpen";
import DOMPurify from "dompurify";
import { useSelector, useDispatch } from "react-redux";
import "./OpenText.scss";

const OpenText = ({ ShowHome }) => {
  const dispatch = useDispatch();
  const [homeObj, setHomeObj] = useState([]);
  const [editId, setEditId] = useState(null);
  const role = useSelector((state) => state.user.role);
  const KIND = "loginMessage";

  const parseItem = useCallback((item) => {
    if (!item) return { id: null, Text: "" };
    const rawId = item.id || item.Id || item._id;
    const rawName = item.name || "";
    const parts = rawName.split("|");
    let extractedText =
      parts.length >= 3 && !rawName.startsWith("<")
        ? parts.slice(2).join("|")
        : rawName;

    return { id: rawId ? String(rawId) : null, Text: extractedText };
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("jwtToken")) return;
    OpenTextGet(KIND)
      .then((x) => {
        if (x.data) setHomeObj(x.data.map(parseItem));
      })
      .catch(() => console.log("error fetching"));
  }, [role, parseItem]);

  const convertContentToHTML = useCallback((value, type, id) => {
    setHomeObj((prev) =>
      prev.map((item) =>
        String(item.id) === String(id) ? { ...item, [type]: value } : item,
      ),
    );
  }, []);

  const deleteText = (id) => {
    if (String(id) === "new") {
      setHomeObj((prev) => prev.filter((i) => String(i.id) !== "new"));
      setEditId(null);
      return;
    }
    dispatch(setPreload(true));
    deleteOpenText(id, KIND)
      .then(() => {
        setHomeObj((prev) => prev.filter((i) => String(i.id) !== String(id)));
      })
      .finally(() => dispatch(setPreload(false)));
  };

  const save = (id) => {
    dispatch(setPreload(true));
    const item = homeObj.find((x) => String(x.id) === String(id));
    if (!item || !item.Text) {
      dispatch(setPreload(false));
      return;
    }

    const dataToSave = { kind: KIND, name: item.Text, id: id };
    const apiCall =
      id === "new" ? addOpenText(dataToSave) : OpenTextSet(dataToSave);

    apiCall
      .then((x) => {
        const parsed = parseItem(x.data);
        setHomeObj((prev) =>
          prev.map((i) => {
            if (String(i.id) === String(id)) {
              return { ...parsed, id: String(parsed.id) };
            }
            return i;
          }),
        );
        setEditId(null);
      })
      .catch((err) => console.error("Save error:", err))
      .finally(() => dispatch(setPreload(false)));
  };

  return (
    <section className="system-message-container">
      {role && ShowHome && (
        <div className="edit-mode-indicator">מצב עריכה פעיל</div>
      )}

      <div className="system-body">
        {homeObj.map((x, index) => {
          const uniqueKey = x.id && x.id !== "new" ? x.id : `item-${index}`;
          const isEditing = editId !== null && String(x.id) === String(editId);

          return (
            <div
              key={uniqueKey}
              className={`item-wrapper ${isEditing ? "editing" : ""}`}
            >
              {ShowHome && role && isEditing ? (
                <Fragment>
                  <div className="edit-controls-top">
                    <button
                      className="btn-base btn-save"
                      onClick={() => save(x.id)}
                    >
                      שמור
                    </button>
                    <button
                      className="btn-base btn-cancel"
                      onClick={() => deleteText(x.id)}
                    >
                      ביטול
                    </button>
                  </div>
                  <MyEditor
                    homeObj={x}
                    convertContentToHTML={(val) =>
                      convertContentToHTML(val, "Text", x.id)
                    }
                  />
                </Fragment>
              ) : (
                <Fragment>
                  <div
                    className="system-text-display"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(x.Text || ""),
                    }}
                  />
                  {role && ShowHome && (
                    <div className="action-buttons-container">
                      <button
                        onClick={() => setEditId(x.id)}
                        className="btn-base btn-edit"
                      >
                        עריכה
                      </button>
                      <button
                        onClick={() => deleteText(x.id)}
                        className="btn-base btn-delete"
                      >
                        מחיקה
                      </button>
                    </div>
                  )}
                </Fragment>
              )}
            </div>
          );
        })}

        {role && ShowHome && (
          <div className="btn-new-message-wrapper">
            <button
              className="btn-add-new"
              onClick={() => {
                if (!homeObj.find((item) => String(item.id) === "new")) {
                  setHomeObj([...homeObj, { id: "new", Text: "" }]);
                }
                setEditId("new");
              }}
            >
              הודעה חדשה
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default OpenText;
